import React, { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import ProfilePicture from 'src/components/ProfilePicture'
import useScript from 'src/components/useScript'
import findPickerMount from './findPickerMount'

const UploadProfilePicture = ({ value, onChange, imageUpload, center, label }) => {
  const setProfilePicture = file =>
    onChange({ target: { value: file.key } })

  const removeProfilePicture = () => {
    if (confirm('Are you sure you want to remove you profile picture?'))
      onChange({ target: { value: '' } })
  }

  const pickFile = () =>
    client.current.picker({
      storeTo: {
        location: 's3',
        path: '/media/images/profile-pictures/',
        container: imageUpload.s3_bucket,
        region: imageUpload.s3_region,
        access: 'public',
      },
      // Pinned rather than left to the default: the whole reason
      // `container` is honoured below is that Filestack gates it on
      // overlay mode (picker's _initContainer), and `container` is
      // documented as an inline/dropPane option — so "container implies
      // inline" is exactly the inference a future version could add.
      displayMode: 'overlay',
      // Picker mount point (distinct from storeTo.container, the S3
      // bucket above) — see findPickerMount.
      container: findPickerMount(),
      // some bug in filestack prevents the array from working when called
      // across frames, but it works with a string, so yeah
      accept: 'image/*',
      transformations: {
        crop: {
          aspectRatio: 1,
          force: true,
        },
        rotate: true,
        circle: true,
      },
      onFileSelected: file => ({
        ...file,
        name: file.filename.replace(/[^\w\.]/g, '')
      }),
      onFileUploadFinished: setProfilePicture,
    }).open()

  const client = useRef()

  const filestackStatus =
    useScript('https://static.filestackapi.com/filestack-js/3.24.1/filestack.min.js',
      { target: top })

  useEffect(() => {
    switch (filestackStatus) {
    case 'ready':
    case 'preexisting':
      client.current ||= top.filestack.init(imageUpload.filestack_api_key)
    }
  }, [ filestackStatus ])

  return (
    <div className={`mb-4 ${center ? 'text-center' : ''}`}>
      <label className="form-label" htmlFor="uploadProfilePicture">
        {label}
      </label>

      <div
        className={center ? 'mx-auto' : null}
        style={{ width: '7.5rem', height: '7.5rem' }}
      >
        {
          value
        ? <div className="position-relative w-100 h-100 rounded-circle border border-primary">
            <ProfilePicture source={value} size="7.5rem" />
            <div className="position-absolute bottom-0 start-0 m-n2 bg-white rounded-circle p-1">
              <button
                type="button"
                id="uploadProfilePicture"
                className="btn btn-sm btn-primary rounded-circle p-0"
                style={{ width: '1.9375rem', height: '1.9375rem' }}
                title="Change Picture"
                onClick={pickFile}
              >
                <FontAwesomeIcon icon="upload" />
              </button>
            </div>
            <div className="position-absolute bottom-0 end-0 m-n2 bg-white rounded-circle p-1">
              <button
                type="button"
                className="btn btn-sm btn-danger rounded-circle p-0"
                style={{ width: '1.9375rem', height: '1.9375rem' }}
                title="Remove Picture"
                onClick={removeProfilePicture}
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </div>
          </div>
        : <button
            type="button"
            id="uploadProfilePicture"
            className="btn btn-outline-primary rounded-circle w-100 h-100"
            style={{ lineHeight: '1.2' }}
            onClick={pickFile}
          >Upload Picture</button>
        }
      </div>
    </div>
  )
}

export default UploadProfilePicture
